import { useSelector } from 'react-redux'
import { selectBrandingColors } from 'store/slices/UI/selectors'

export const useBrandingColors = () => {
  return useSelector(selectBrandingColors)
}
